import React, { useState, useEffect } from "react";
import {
  isBookmarked,
  addBookmark,
  removeBookmark,
} from "../../utils/bookmarksHelper";
import "./ProductCard.css";

const ProductCard = ({ product, categoryId }) => {
  const [isBookmarkedState, setIsBookmarkedState] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // Check if item is bookmarked on mount and listen for removal events
  useEffect(() => {
    setIsBookmarkedState(isBookmarked(product.id, categoryId));

    // Listen for bookmark removal events
    const handleBookmarkRemoved = (event) => {
      const { productId, categoryId: removedCategoryId } = event.detail;
      if (productId === product.id && categoryId === removedCategoryId) {
        setIsBookmarkedState(false);
      }
    };

    window.addEventListener("bookmarkRemoved", handleBookmarkRemoved);

    return () => {
      window.removeEventListener("bookmarkRemoved", handleBookmarkRemoved);
    };
  }, [product.id, categoryId]);

  const toggleBookmark = () => {
    if (isBookmarkedState) {
      const success = removeBookmark(product.id, categoryId);
      if (success) {
        setIsBookmarkedState(false);
      }
    } else {
      const success = addBookmark(product, categoryId);
      if (success) {
        setIsBookmarkedState(true);
      }
    }
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = (e) => {
    setImageError(true);
    setImageLoading(false);
    e.target.style.display = "none";
  };

  return (
    <div className="product-card">
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <div className="product-price">{product.price}</div>

        {product.description && (
          <p className="product-description">{product.description}</p>
        )}

        {product.tags && (
          <div className="product-tags">
            {product.tags.map((tag, index) => (
              <span key={index} className="product-tag">
                {/* {tag === "Додайте щось" && "💙"}
                {tag === "Тепле" && "🔥"} */}
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="product-right">
        <div className="product-image-container">
          {/* Loading spinner - shows while image is loading */}
          {imageLoading && !imageError && (
            <div className="product-image-spinner">
              <div className="spinner"></div>
            </div>
          )}

          {/* Product image */}
          <img
            src={product.image}
            alt={product.name}
            className={`product-image ${imageLoading ? "loading" : ""}`}
            loading="lazy"
            decoding="async"
            onLoad={handleImageLoad}
            onError={handleImageError}
          />

          {/* Bookmark button */}
          <button
            className={`bookmark-btn ${isBookmarkedState ? "bookmarked" : ""}`}
            onClick={toggleBookmark}
            aria-label={
              isBookmarkedState ? "Видалити з закладок" : "Додати до закладок"
            }
          >
            {isBookmarkedState ? "❤️" : "🤍"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
